import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const Step = ({
  title,
  isActive,
  stepIcon,
  hide,
  activeIcon,
  forwardStepIcon,
  isCompleted,
  activeStep,
  isDeal,
  iconSize = '36px',
  size,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div
        className={classNames('step', {
          'step--active': isActive,
          'step--completed': isCompleted,
          'step--hidden': hide,
          'step-deal': isDeal && activeStep == '4',
        })}
      >
        <div className="step__icon">
          <img
            alt="icon"
            className="icon-img"
            src={
              isActive ? activeIcon : isCompleted ? stepIcon : forwardStepIcon
            }
          />
        </div>
        <p
          className={classNames('step__desc', {
            'step--active': isActive,
            'step--completed': isCompleted,
            'step--hidden': hide,
          })}
        >
          {title}
        </p>
      </div>

      <style jsx>{`
        .step {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          color: ${theme.colors.stepinactivecolor};
        }
        .step-deal {
          top: -7px;
        }
        .step--hidden {
          display: none;
        }
        .step--active {
          color: ${theme.colors.stepactivecolor};
        }
        .step--completed {
          color: ${theme.colors.stepcompletedcolor};
          font-weight: bold;
          font-size: ${size - 2}px;
          justify-content: center;
          display: flex;
        }
        .step__icon {
          width: calc(0.8 * ${iconSize});
          height: calc(0.8 * ${iconSize});
          object-fit: cover;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
          border-radius: 50%;
        }
        .icon-img {
          width: 100%;
          height: 100%;
        }
        .step__desc {
          margin-top: 8px;
          text-transform: capitalize;
          max-width: 70px;
          line-height: 13px;
          text-align: center;
        }
        .step:not(:first-child):after {
          content: '';
          position: relative;
          height: 1.2px;
          width: calc(100% - 0.8 * ${iconSize});
          top: calc(${iconSize} * 0.8 / 2);
          left: -50%;
          background-color: ${isActive
            ? theme.colors.stepactivecolor
            : theme.colors.stepinactivecolor};
          order: -1;
        }

        @media (min-width: ${theme.breakpoints.smUp}) {
          .step__icon {
            width: ${iconSize};
            height: ${iconSize};
          }
          .step__desc {
            font-size: 12px;
            line-height: 16px;
          }
          .step--completed {
            color: ${theme.colors.stepcompletedcolor};
            font-weight: bold;
            font-size: ${size}px;
          }
          .step:not(:first-child):after {
            width: calc(100% - ${iconSize});
            height: 1.5px;
            top: calc(${iconSize} / 2);
          }
        }
      `}</style>
    </>
  );
};

Step.propTypes = {
  activeIcon: PropTypes.any,
  hide: PropTypes.bool,
  iconSize: PropTypes.string,
  isActive: PropTypes.bool,
  stepIcon: PropTypes.any,
  title: PropTypes.string.isRequired,
};

export default Step;
